// Clinic Configuration for Todays Dental Greenville
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Todays Dental Greenville",
  clinicId: "todaysdentalgreenville",
  clinicUrl: "https://todaysdentalgreenville.com",
  // Contact Information
  phoneNumber: "864-999-9899",
  phoneNumberRaw: "+18649999899", // For tel: and sms: links
  email: "Dentist@TodaysDentalGreenville.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=todaysdentalgreenville&agentId=e20ed72b-cfcf-4169-96c8-2f064baf42d6",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/todaysdentalgreenville/voice",

  // Location
  address: "1530 Poinsett Hwy Greenville, SC 29609, USA",
  addressShort: "1530 Poinsett Hwy Greenville, SC 29609",
  city: "Greenville",
  hcity: 'Greenville',
  state: "South Carolina",
  stateShortForm: "SC",
  PostalCode: "29609",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/ksQRNsjQsjH7VNUa9",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d402539.0278482628!2d-82.404153!3d34.889506!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88583159347e9ab5%3A0x73edad4ca8608090!2sTodays%20Dental%20%40%20Greenville!5e1!3m2!1sen!2sin!4v1756793652385!5m2!1sen!2sin',
  iframeTitle: "Todays Dental Greenville",

  //membership
  membership: "https://member.kleer.com/?slug=KR2H",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalatGreenville",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/todays-dental-at-greenville?utm_source=practice&utm_medium=email&m=65976",


  // Analytics
  clarityProjectId: "prcd3zvx6c",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/todaysdentalgreenville",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/todaysdentalgreenville",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/todaysdentalgreenville",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/TodaysdentalGreenvilleSC",
    instagram: "https://www.instagram.com/stories/todaysdentalgreenville/",
    twitter: "https://twitter.com/td_greenville",
    linkedin: "https://www.linkedin.com/company/todays-dental-at-greenville/",
    youtube: "https://www.youtube.com/@todaysdentalgreenville",
  },

  // Open Dental Configuration
  defaultProvNum: 28,
  defaultOpNum: 25,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 26,
      AppointmentTypeNum: 1
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 25,
      AppointmentTypeNum: 32
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 25,
      AppointmentTypeNum: 6
    }
  ],


  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
